import type { MouseEvent } from 'react';

import ArticleCard, {
  type ArticleCardDataProps,
} from '@/app/components/ArticleCardsModule/ArticleCard';

const ArticleCardsDesktop = ({
  articleCards,
  onClick,
}: {
  readonly articleCards: ArticleCardDataProps[];
  readonly onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
}) => {
  return (
    <div className="hidden grid-cols-3 gap-4 lg:grid">
      {articleCards.map(({ heading, ...props }) => {
        return (
          <ArticleCard
            key={heading}
            heading={heading}
            {...props}
            onClick={onClick}
          />
        );
      })}
    </div>
  );
};

export default ArticleCardsDesktop;
